export const youtube = {
  "header-de": "Gottesdienst online sehen",
  "text-de": "10:00-12:00 | 17:30-19:00",
  "subtitle-de": "JEDEN SONNTAG MORGEN & ABEND",
  "button-de": "Archiv",
  "header-ro": "Vezi programul online",
  "text-ro": "10:00-12:00 | 17:30-19:00",
  "subtitle-ro": "FIECARE DUMINICĂ DIMINEAȚA & DUPĂ-MASA",
  "button-ro": "Arhivă"
}
